import { css } from '@emotion/css';
import { colorsV1 } from '@ajaibid/components';
import stylesGlobal from '../../screens/style';

export const styModal = ({ width = '' } = {}) => css`
  .modal-content {
    ${width ? `width: ${width};` : 'width: 639px;'}
    box-shadow: 0px 8px 16px rgba(51, 51, 51, 0.08);
    border-radius: 8px;
    border: none;
  }
`;

export const styModalInner = ({ align }) => css`
  padding: 24px;
  text-align: ${align};
`;

export const styModalLoader = ({ width = '' } = {}) => css`
  .modal-content {
    ${width ? `width: ${width};` : 'width: 639px;'}
    box-shadow: 0px 8px 16px rgba(51, 51, 51, 0.08);
    border-radius: 8px;
    border: none;
  }
`;

export const styPopUpDialog = css`
  padding: 24px;
  text-align: center;
`;


export const styEmailSupportWrapper = css`
  margin-top: 16px;
`
export const styEmailSupportContent = css`
  border-radius: 4px;
  display: flex;
  flex-flow: row wrap;
  text-align: left;
  padding: 16px;
  margin: 8px 0 0;
  cursor: pointer;
  &:hover{
    background: ${colorsV1.N50};
  }
`

export const styEmailSupportImage = css`
  align-self: center;
`

export const styEmailSupportTitle = css`
  font-weight: bold;
`

export const styEmailSupportText = css`
  margin-left: 16px;
  display: flex;
  flex-flow: column;
  align-self: center;
  font-size: 16px;
`

const styles = {
  modalContainer: {
    height: '100vh',
    alignItems: 'center',
    justifyContent: 'center',
    display: 'flex',
    marginTop: 0,
    position: 'relative',
  },
  modalSideContainer: {
    position: 'fixed',
    bottom: 0,
    right: 16,
    flexWrap: 'unset',
    zIndex: 999,
  },
  modalSideContent: {
    padding: 0,
    width: 420,
    height: 602, // I changed back to px because on big resolution desktop is too long
    maxHeight: 'calc(100vh - 52px)',
    // boxShadow: '0 -2px 24px 0 rgba(51, 51, 51, 0.16)',
    border: `solid 1px ${stylesGlobal.neutral50}`,
    backgroundColor: stylesGlobal.neutral0,
    borderRadius: '8px 8px 0px',
    borderLeft: 0,
    boxShadow: 'rgba(51, 51, 51, 0.08) 0px 2px 8px 0px',
  },
  modalSideActions: {
    position: 'absolute',
    bottom: 0,
    width: '100%',
    padding: '8px 16px',
  },
  modalCenterHeader: {
    ...stylesGlobal.center,
    borderBottom: 'none',
    // boxShadow: '0 2px 8px 0 rgba(51, 51, 51, 0.08)',
  },
  modalCenterHeaderShadow: {
    ...stylesGlobal.center,
    borderBottom: 'none',
    boxShadow: '0 4px 2px -2px rgba(51, 51, 51, 0.08)',
  },
};

export default styles;
